import { AnyAction } from 'redux';
import { GlobalActions, ZahlungsoptionenChanged } from '@ps20-frontend/shop-integration-redux';
import { Zahlweise } from '@ps20/bff-models';

export const zahlungsweiseReducer = function (
  sectionState: Zahlweise = null,
  action: AnyAction,
): Zahlweise {
  switch (action.type) {
    case GlobalActions.ZAHLUNGSOPTIONEN_CHANGED:
    case GlobalActions.ZAHLUNGSOPTIONEN_CHANGED_VORVERTRAG: {
      const actionPayload: ZahlungsoptionenChanged = action.payload;
      if (actionPayload.zahlungsweise) {
        return actionPayload.zahlungsweise;
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
